// extracted by mini-css-extract-plugin
export default {"wlContainer":"WorkList_wlContainer__PyN30","wlEmptyList":"WorkList_wlEmptyList__Kx6hS"};